import { Image, ImageProps } from "@react-pdf/renderer";

export type CarPdfImageProps = ImageProps;

export const CarPdfImage = (props: CarPdfImageProps) => <Image {...props} />;
